<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <b-card class="bCardGlobal">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Quejas</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>C-**</div>
        </b-col>
      </b-row>

      <b-row class="divSubtitulo">
        <b-col>
          <p class="textSubtitulo">Complementación de datos</p>
        </b-col>
      </b-row>


       <div class="container-fluid main-component ">
        <div class="row justify-content-center">
          <div class="col-sm-12 col-md-8 col-lg-8 col-xl-4">
            <b-card
                style="
                padding: 1%;
                border-radius: 20px;
                box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
              "
            >
              <p
                  style="
                  text-align: left;
                  color: #093974;
                  font-size: 18px;
                  font-weight: 600;
                "
              >
                Información del paciente
              </p>
              <b-table-simple responsive style="margin-top: 7%">
                <tr>
                  <td style="font-size: 15px"><label>ID Paciente</label></td>
                  <td style="font-size: 15px">{{ datos.idPaciente }}</td>
                </tr>
                <tr>
                  <td style="font-size: 15px">
                    <label>Nombre del Paciente</label>
                  </td>
                  <td style="font-size: 15px">{{ datos.paciente }}</td>
                </tr>
              </b-table-simple>
              <div style="margin-top: 10%">
                <p>
                  A través de <strong>{{ datos.origen }}</strong> el paciente
                  comenta:
                </p>
                <p v-if="datos.comentarios.length < 160">
                  <strong>{{ datos.comentarios }}</strong>
                </p>
                <b-button v-else @click="modalComentarios=true">Ver comentarios</b-button>
              </div>
            </b-card>
          </div>
        <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8">
         <p
              style="
                text-align: left;
                color: #093974;
                font-size: 18px;
                font-weight: 600;
              "
              class="mt-4"
            >
              Información
            </p>
                            <b-form-group align="left">
   
                <label>¿Px aceptó la solución?</label>
       
                <v-select
                style="width: 60%"
                    :options="select"
                    label="text"
                    :reduce="(fin) => fin.value"
                    v-model="$v.form.px.$model"
                    :state="validateState('px')"
                    :class="selectClass('px')">
                  >
                </v-select>
          </b-form-group>

          </div>

        </div>
      </div>
      <b-row class="pb-3 text-center">
        <b-col>
          <b-button variant="outline-primary" :disabled="loaderGuardar" @click="guardar()">
            <span v-if="!loaderGuardar">Guardar</span>
            <span v-if="loaderGuardar">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
       <b-modal
        v-model="modalComentarios"
        title="Comentarios del paciente"
        scrollable
        size="lg"
    >
      <p style="font-size: 18px; font-weight: 600; ">El paciente comenta:</p>
      <div class="container-fluid main-component p-3 text-justify">

        <p>{{ datos.comentarios }}</p>
      </div>
    </b-modal>
  
  </div>
</template>

<script>
import Header from "../../../components/Header";
import {GarantiaService} from "../../../apiServices/garantias/GarantiaService";
import {required} from "vuelidate/lib/validators";

export default {
  name: "AceptacionSolicitud",
  components: {Header},
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

    modalComentarios:false,
      garantiaServicio: new GarantiaService(),
      idTicket: null,
      idEtapa: null,
      loaderGuardar: false,
      select: [
        {value: true, text: 'Si'},
        {value: false, text: 'No'}
      ],
      datos: {
        origen: '',
        comentarios: '',
        idPaciente: '',
        paciente: '',
        driver: '',
        tema: '',
        subtema: '',
      },
      form: {
        px: null
      }
    }
  },
  validations: {
    form: {
      px: {required},
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idTicket = this.$route.params.id;
    this.idEtapa= this.$route.params.idEtapa
    this.obtenerInformacionTicket();
  },
  methods: {
    obtenerInformacionTicket() {
      const parametros = {idTicket: this.idTicket}
      this.garantiaServicio.obtenerTicket(parametros)
          .then(respuesta => {
            this.datos = respuesta.data
          })
    },
    guardar() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return false;
      }
      this.loaderGuardar = true
      const envio = JSON.parse(JSON.stringify(this.form))
      envio.idSolicitud = this.idTicket;
      envio.idEtapa = this.idEtapa;
      this.garantiaServicio.finalizar(envio)
          .then(() => {
            this.$swal({
              icon: "success",
              title: "Se registro correctamente",
              showConfirmButton: false
            });
            this.$v.$reset()
            window.history.back();
          })
          .finally(() => {
            this.loaderGuardar = false;
          })
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute)
      if (state) {
        return 'border rounded-lg border-success'
      } else if (state === false) {
        return 'border rounded-lg border-danger'
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>
</style>
